
/**
 * @file 核酸检测机构页面
 * @author hukeke01
 */
import {rcAjax} from '../util';
import {
    UPDATE_LOC_SELECT,
    UPDATE_USER_POSITION,
    AREA_DICT,
    LOCATION_RESULT,
    UPDATE_USER_POINT
} from './ActionTypes';


export function setLocSelect(dispatch, obj) {
    dispatch({
        type: UPDATE_LOC_SELECT,
        data: obj
    });
    return obj;
}

export function setUserPosition(dispatch, obj) {
    dispatch({
        type: UPDATE_USER_POSITION,
        data: obj
    });
    return obj;
}

export function setUserPoint(dispatch, obj) {
    dispatch({
        type: UPDATE_USER_POINT,
        data: obj
    });
    return obj;
}
export function getAreaData(dispatch, params) {
    return rcAjax('POST', '/api/v1/smart/area', {}, params, data => {
        dispatch({type: AREA_DICT, data: data.data});
    });
}

export function getLocationResult(dispatch, params) {
    return rcAjax('POST', '/api/v1/smart/nata', {}, params, data => {
        dispatch({type: LOCATION_RESULT, data: data.data});
    });
}